import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { config } from '@app/core/app-config';

@Injectable({
  providedIn: 'root',
})
export class PreferencesService {
  uiPrefsUrl = `${config.API_URL}/user/preferences/ui`;

  constructor(private http: HttpClient) {}

  public setUiPreference(key: string, payload: any) {
    return this.http
      .post(this.uiPrefsUrl, {
        key,
        payload,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
}
